






























































































































































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import { LearningRequestShortList as ILearningRequestShortList } from "@/api/models/learning-request-short-list";
import SelectEntity from "@/components/form/SelectEntity.vue";
import learningRequests, {
  LearningRequestsListParams
} from "@/getinfo-api/learning-requests";
import { LearningRequestsListParamsV2 } from "@/getinfo-api/learningRequestsV2";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import { Employee as IEmployee } from "@/api/models/employee";
import { LearningRequestShort as ILearningRequestShort } from "@/api/models/learning-request-short";
import { User as IUser } from "@/api/models/user";
import { availableStatuses, learningStatus } from "@/plugins/learning-status";
import {
  currentUserIsCompanyOwner,
  getCurrentCompanyId,
  getCurrentUserId,
  isRoot
} from "@/plugins/roles";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import { LearningRequestSort, SortFields } from "@/plugins/sort-fields";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import OrderItemCard from "@/components/orders/OrderItemCard.vue";
import OrdersListKanban from "@/components/orders/OrdersListKanban.vue";
import { LearningRequestChangeStatus as ILearningRequestChangeStatus } from "@/api/models/learning-request-change-status";
import api, { settingStorageApi } from "@/getinfo-api";
import { uniqBy as _uniqBy } from "lodash";
import LearningRequestFilter from "@/components/learning-request-v2/LearningRequestFilter.vue";
import LearningRequestTable from "@/components/learning-request-v2/LearningRequestTable.vue";
import { quickDocumentCreationModule } from "@/plugins/modules-detect";
import {
  Category as ICategory,
  CategoryList as ICategoryList,
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import { AxiosError } from "axios";

@Component({
  components: {
    LearningRequestTable,
    LearningRequestFilter,
    OrdersListKanban,
    CSingleSelect,
    CBlock,
    CField,
    CPage,
    CustomTable,
    CustomButton,
    OrderItemPreview,
    SelectEntity,
    CustomDatepicker,
    OrderItemCard
  }
})
export default class OrdersList extends Vue {
  @Ref("kanban") kanban!: OrdersListKanban;
  spinner: boolean = false;
  name: string | undefined;
  courseTitle: string | undefined;
  requests: Array<ILearningRequestShort> = [];
  number: string | undefined;
  resourceType: string | undefined;
  responsibleId: string | undefined;
  clientType: string | undefined;
  clientId: string | undefined;
  categoryList!: Array<ICategory>;
  categoryId!: string | any;
  formedAtMin!: Date | undefined;
  formedAtMax!: Date | undefined;
  status!: string | undefined;
  employeeList!: Array<IEmployee>;
  limit: number = 30;
  offset: number = 0;
  requestCount!: number;
  sorted: SortFields<LearningRequestSort> = new SortFields(
    LearningRequestSort.formedAt
  );
  contractorList: ContractorsListClass = new ContractorsListClass({
    companyId: this.selectedCompanyId
  });
  isListView: boolean = true;
  version: string = "1";
  paramsV2!: LearningRequestsListParamsV2;
  countV2: number = 0;
  checkedRequests: ILearningRequest[] = [];

  data() {
    return {
      paramsV2: undefined,
      name: undefined,
      number: undefined,
      resourceType: undefined,
      responsibleId: undefined,
      courseTitle: undefined,
      clientType: undefined,
      clientId: undefined,
      categoryId: undefined,
      formedAtMax: undefined,
      categoryList: undefined,
      formedAtMin: undefined,
      status: undefined,
      employeeList: undefined,
      requestCount: undefined
    };
  }

  getAllCategory() {
    let params: CategoriesListParams = {
      companyId: this.companyId,
      limit: 600
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoryList = res.data.items;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  selectRequest(request: ILearningRequest) {
    this.checkedRequests.includes(request)
      ? (this.checkedRequests = this.checkedRequests.filter(
          el => el !== request
        ))
      : this.checkedRequests.push(request);
  }
  get checkedQuery() {
    return this.checkedRequests.map(el => el.id).join(",");
  }

  get isQuickDocumentCreation() {
    return quickDocumentCreationModule();
  }

  acceptSort(sort: LearningRequestSort) {
    this.sorted.changeSort(sort);
    this.applyFilter();
  }
  getCountV2(val: number) {
    this.countV2 = val;
  }

  getOnlyCurrentContractors() {
    return this.clientType === "juridical"
      ? this.$store.state.user.user.juridicalContractor
      : this.$store.state.user.user.physicalContractor;
  }

  @Watch("clientType")
  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = this.clientType
      ? this.clientType
      : undefined;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  get sortStatus() {
    return LearningRequestSort;
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get learningManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }

  get userId() {
    return getCurrentUserId();
  }

  get allStatuses() {
    return availableStatuses();
  }

  changeToListView() {
    this.isListView = true;
    this.requests = [];
    this.offset = 0;
    this.searchOrdersByParams();
  }

  changeToKanbanView() {
    this.isListView = false;
    this.getRequestByStatuses();
  }

  async getRequestByStatuses() {
    const statuses = [
      "not_processed",
      "waiting_payment",
      "learning",
      "learning_finished",
      "documents_ready",
      "completed",
      "cancelled"
    ];

    this.requests = [];

    this.spinner = true;
    await Promise.allSettled(
      statuses.map(async status => {
        const requestParams: LearningRequestsListParams = {
          companyId: this.selectedCompanyId,
          //@ts-ignore
          status: status,
          responsibleId: this.responsibleId,
          limit: this.limit,
          sort: "formedAt",
          order: this.sorted.order,
          offset: 0
        };

        let { data } = await learningRequests(requestParams);
        if (data?.requests?.length) {
          this.requests = [...this.requests, ...data?.requests];
        }
      })
    );
    this.spinner = false;
    this.kanban.sortedByStatuses();
  }

  kanbanScrollEnd() {
    if (this.requestCount > this.requests.length) {
      this.showMore();
    }
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  async getStudentLimit() {
    if (this.companyId) {
      settingStorageApi.Company.getCompanySettings(this.companyId, [
        "studentLimit"
      ]).then(res => {
        //@ts-ignore
        this.$store.state.studentLimit = +res.data[0].value.amount;
      });
    }
  }
  async getStudentActive() {
    api.CourseApi.listenersCountGlobal(this.companyId).then(res => {
      this.$store.state.studentAmount = +res.data;
    });
  }

  changeStatusKanban(status: string, request: ILearningRequest) {
    const params: ILearningRequestChangeStatus = {
      //@ts-ignore
      status: status,
      handle: true
    };

    api.LearningRequestApi.changeStatus(request.id, params)
      .then((res: { data: ILearningRequest }) => {
        const index = this.requests.findIndex(el => el.id === res.data.id);
        this.requests[index].status = res.data.status;
        if (
          res.data.status === "learning_finished" &&
          this.$store.getters["companyUtils/getIsFinishLearningWithEndLr"]
        ) {
          api.CourseApi.pass(
            res.data.resourceId,
            //@ts-ignore
            (res.data.payload.course_listeners as string[]).map(el => {
              return { listenerId: el, success: true };
            })
          );
        }

        this.getStudentActive();
        this.getStudentLimit();
        this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Success)}`
        });
      })
      .catch(err => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.kanban.sortedByStatuses();
      });
  }

  changeStatus(data: Array<any>) {
    let [status, index] = [...data];
    this.requests[index].status = status;
  }

  getEmployeeId() {
    if (!this.root && !this.companyOwner) {
      let param: EmployeeListParams = {
        id: this.selectedCompanyId,
        userIds: [this.userId],
        roles: ["learning_request_manager"]
      };

      employee(param)
        .then((res: { data: IEmployeesList2 }) => {
          if (res.data.employees.length) {
            this.responsibleId = res.data.employees[0].id;
          }
        })
        .finally(() => {
          this.searchOrdersByParams();
        });
    } else {
      let params: EmployeeListParams = {
        roles: ["learning_request_manager"],
        id: this.selectedCompanyId,
        limit: 300
      };
      employee(params).then((res: { data: IEmployeesList2 }) => {
        this.employeeList = res.data.employees;
      });
      this.searchOrdersByParams();
    }
  }

  getLabel(option: IEmployee) {
    let label;
    label = `${option.user.fullName}`;
    return label;
  }

  selectUser(user: IUser) {
    this.clientId = user.id;
  }

  formattedStatuses(item: string) {
    return learningStatus(item);
  }

  showMore() {
    this.offset += this.limit;
    this.searchOrdersByParams(this.offset);
  }

  mounted() {
    if (this.selectedCompanyId) {
      this.getEmployeeId();
      this.getAllCategory();
    }
  }

  applyFilter() {
    this.requests = [];
    this.offset = 0;
    this.searchOrdersByParams(this.offset);
  }

  searchOrdersByParams(offset: number = 0) {
    this.spinner = true;
    let params: LearningRequestsListParams = {
      companyId: this.selectedCompanyId,
      number: this.number ? this.number : undefined,
      resourceType: this.resourceType ? this.resourceType : undefined,
      responsibleId: this.responsibleId ? this.responsibleId : undefined,
      //@ts-ignore
      contractorType: this.clientType ? this.clientType : undefined,
      contractorId: this.clientId ? this.clientId : undefined,
      formedAtMin: this.formedAtMin ? this.formedAtMin : undefined,
      formedAtMax: this.formedAtMax ? this.formedAtMax : undefined,
      categoryId: this.categoryId,
      courseTitle: this.courseTitle,
      //@ts-ignore
      status: this.status ? this.status : undefined,
      limit: this.limit,
      offset: offset,
      sort: this.sorted.sort,
      order: this.sorted.order
    };
    learningRequests(params)
      .then((res: { data: ILearningRequestShortList }) => {
        this.requestCount = res.data.count;
        this.requests = [...this.requests, ...res.data.requests];
        this.requests = _uniqBy(this.requests, "id");
      })
      .finally(() => {
        this.kanban.sortedByStatuses();
        this.spinner = false;
      });
  }

  clearForm() {
    this.offset = 0;
    this.number = undefined;
    this.status = undefined;
    this.resourceType = undefined;
    this.responsibleId =
      this.root || this.companyOwner ? undefined : this.responsibleId;
    this.clientType = undefined;
    this.clientId = undefined;
    this.categoryId = undefined;
    this.courseTitle = undefined;
    this.formedAtMax = undefined;
    this.formedAtMin = undefined;
    this.requests = [];
    this.searchOrdersByParams();
  }

  @Watch("selectedCompanyId")
  updateOrders() {
    this.requests = [];
    this.getEmployeeId();
  }
}
